import { partnerSites } from './partnerSites.const';

export const allowedOrigins = partnerSites.map(site => site.origin);
